<ion-content class="app-shell profile-shell">
  <div
    class="section-top-bar profile-top-bar"
    *ngIf="fromPage === 'admin'"
  >
    <button
      type="button"
      class="back-btn"
      data-testid="profile-back"
      (click)="goBack()"
    >
      <ion-icon name="chevron-back-outline"></ion-icon>
    </button>

    <h2 class="section-title flex-grow-1 mb-0 text-center">
      {{ pageTitle | translate }}
    </h2>
  </div>
  <section class="app-surface-card profile-panel">
    <div class="profile-hero-card profile-hero">
      <button
        type="button"
        class="profile-avatar-btn"
        [disabled]="isUploadingPhoto"
        [attr.aria-label]="'PROFILE.TITLE' | translate"
        (click)="isOwnProfile ? presentProfilePhotoActionSheet() : viewPhoto()"
      >
        <ion-avatar>
          <img
            class="profile-avatar-fallback"
            [src]="defaultPicture"
            alt=""
            aria-hidden="true"
          />
          <div
            *ngIf="showImageLoader && !isUploadingPhoto"
            class="profile-avatar-loading"
          >
            <ion-spinner name="crescent"></ion-spinner>
          </div>
          <img
            *ngIf="hasCustomProfilePicture"
            class="profile-avatar-photo"
            [src]="previewUrl || profilePicture || defaultPicture"
            [class.is-loaded]="imageLoaded"
            [class.is-uploading]="isUploadingPhoto"
            (load)="onImageLoad()"
            (error)="onImageError($event)"
            alt=""
          />
          <div *ngIf="isUploadingPhoto" class="uploading-overlay">
            <ion-spinner name="crescent"></ion-spinner>
          </div>
        </ion-avatar>
      </button>
      <div class="profile-hero-text">
        <h1 class="app-hero-title profile-name">{{ fullName }}</h1>
        <p class="profile-contact" *ngIf="email">{{ email }}</p>
        <p class="profile-contact" *ngIf="phone">{{ phone }}</p>
      </div>
    </div>

  <!-- Menu items -->
  <ion-list class="app-menu-list responsive-list">
    <ion-item
      class="app-menu-item"
      data-testid="profile-personal"
      (click)="goToSegment('personal')"
      lines="none"
      detail="false"
    >
      <ion-icon color="primary" slot="start" name="person-outline"></ion-icon>
      <ion-label>
        <h3>{{ 'PROFILE.PERSONAL_INFO' | translate }}</h3>
        <p>{{ 'PROFILE.EDIT_PERSONAL_INFO' | translate }}</p>
      </ion-label>
    </ion-item>

    <ion-item
      class="app-menu-item"
      data-testid="profile-cars"
      (click)="goToSegment('cars')"
      lines="none"
      detail="false"
    >
      <ion-icon color="primary" slot="start" name="car-outline"></ion-icon>
      <ion-label>
        <h3>{{ 'PROFILE.CAR_INFO' | translate }}</h3>
        <p>{{ 'PROFILE.MANAGE_CARS' | translate }}</p>
      </ion-label>
    </ion-item>

    <ion-item
      class="app-menu-item"
      data-testid="profile-subscriptions"
      (click)="goToSegment('subscriptions')"
      lines="none"
      detail="false"
    >
      <ion-icon color="primary" slot="start" name="bookmark-outline"></ion-icon>
      <ion-label>
        <h3>{{ 'PROFILE.SUBSCRIPTIONS' | translate }}</h3>
        <p>{{ 'PROFILE.MANAGE_SUBSCRIPTIONS' | translate }}</p>
      </ion-label>
    </ion-item>

    <ion-item
      class="app-menu-item"
      *ngIf="isOwnProfile"
      data-testid="profile-notifications"
      (click)="goToSegment('notifications')"
      lines="none"
      detail="false"
    >
      <ion-icon
        color="primary"
        slot="start"
        name="notifications-outline"
      ></ion-icon>
      <ion-label>
        <h3>{{ 'PROFILE.NOTIFICATIONS' | translate }}</h3>
        <p>{{ 'PROFILE.MANAGE_NOTIFICATIONS' | translate }}</p>
      </ion-label>
    </ion-item>

    <ion-item
      class="app-menu-item"
      *ngIf="isOwnProfile"
      data-testid="profile-account"
      (click)="goToSegment('account')"
      lines="none"
      detail="false"
    >
      <ion-icon
        color="primary"
        slot="start"
        name="shield-checkmark-outline"
      ></ion-icon>
      <ion-label>
        <h3>{{ 'PROFILE.ACCOUNT_MANAGEMENT' | translate }}</h3>
        <p>{{ 'PROFILE.MANAGE_ACCOUNT' | translate }}</p>
      </ion-label>
    </ion-item>

    <ion-item lines="none" detail="false" class="app-menu-item language-item">
      <div class="language-layout">
        <div class="language-main">
          <ion-icon color="primary" name="language-outline"></ion-icon>

          <ion-label>
            <h3>{{ 'USER_DETAILS.Language' | translate }}</h3>
          </ion-label>
        </div>

        <div class="language-dropdown-shell">
          <ion-select
            class="language-select-control"
            data-testid="profile-language"
            [value]="currentLang"
            (ionChange)="switchLang($event.detail.value)"
            interface="popover"
            [interfaceOptions]="languageSelectOptions"
            toggleIcon="chevron-down-outline"
            [attr.aria-label]="'USER_DETAILS.Language' | translate"
          >
            <ion-select-option value="en">English</ion-select-option>
            <ion-select-option value="fr">Français</ion-select-option>
            <ion-select-option value="ar">العربية</ion-select-option>
          </ion-select>
        </div>
      </div>
    </ion-item>
    <app-dark-mode-toggle *ngIf="isOwnProfile"></app-dark-mode-toggle>

    <ion-item
      lines="none"
      detail="false"
      class="app-menu-item profile-version-item no-list-hover"
      data-testid="profile-app-version"
    >
      <ion-icon slot="start" color="primary" name="phone-portrait-outline"></ion-icon>
      <ion-label>
        <h3>{{ 'PROFILE.APP_VERSION' | translate }}</h3>
        <p>Bidarbak</p>
      </ion-label>
      <ion-note slot="end" class="profile-version-value">{{ appVersion }}</ion-note>
    </ion-item>

    <ion-item
      class="app-menu-item app-menu-item--danger"
      *ngIf="isOwnProfile"
      data-testid="profile-logout"
      (click)="logout()"
      lines="none"
      detail="false"
    >
      <ion-icon slot="start" color="danger" name="log-out-outline"></ion-icon>
      <ion-label color="danger"
        ><strong>{{ 'PROFILE.LOG_OUT' | translate }}</strong></ion-label
      >
    </ion-item>
  </ion-list>
  </section>
</ion-content>
